import { FaClock, FaFileSignature, FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const cards = [
    { title: "Pendientes",   value: "8",  icon: <FaClock /> },
    { title: "Emitidos Hoy", value: "15", icon: <FaFileSignature /> },
    { title: "Validados",    value: "3",  icon: <FaCheckCircle /> },
    { title: "Rechazados",   value: "1",  icon: <FaTimesCircle /> },
];

function FuncionarioStats() {
    return (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
            {cards.map((card, index) => (
                <div
                    key={index}
                    className="flex items-center justify-between rounded-[var(--radius-md)] bg-surface p-[22px] shadow-[0_8px_20px_rgba(0,0,0,0.05)] transition-transform duration-250 hover:-translate-y-1"
                >
                    <div>
                        <span className="text-sm text-text-muted">{card.title}</span>
                        <h2 className="mt-[10px] text-[32px] font-bold text-primary">{card.value}</h2>
                    </div>
                    <span className="text-[34px] text-primary">{card.icon}</span>
                </div>
            ))}
        </div>
    );
}

export default FuncionarioStats;
